<template>
  <div id="app">
    <v-head ref="header" ></v-head>

    <!-- <keep-alive :include="keepAliveList">
      <router-view style="width: 100%; overflow: hidden;"></router-view>
    </keep-alive> -->
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        style="width: 100%; overflow: hidden;"
      ></router-view>
    </keep-alive>
    <router-view
      v-if="!$route.meta.keepAlive"
      style="width: 100%; overflow: hidden;"
    ></router-view>
    <v-footer />

  </div>
</template>

<script>
import { mapState } from "vuex";

import vHead from './views/common/Header.vue';
import vFooter from './views/common/footer.vue';
export default {
  name: "App",
  components: {
    vHead,
    vFooter
  },
  data() {
    return {
      keepAliveList: ['home', 'index','articleDetails','article']
    }
  },
  computed: {
    ...mapState(["isPc"]),
  },
  created() {
    this.$store.dispatch("checkToken");
    this.$store.dispatch("getWebInfo");
    this.$store.dispatch("checkWindowWidth");
    
  },
};
</script>


// WEBPACK FOOTER //
// src/App.vue